   import { useWorkoutsContext } from "../hooks/useWorkoutsContext"
   import {useAuthContext} from '../hooks/useAuthContext'
   
   const WorkoutDetails = ({workout})=> {

    const { dispatch } = useWorkoutsContext()
    const {user} = useAuthContext()
    
    const handleClick = async() => {
        
        if (!user) {
            return}
            
        const response = await fetch('https://webservicetry1.onrender.com/api/products/' + workout._id,{
            method:'DELETE',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${user.token}`
        }
        })
        
    const json = await response.json()
    dispatch({type:'DELETE_WORKOUT',payload :json})
    }

    const url =workout.imageName
    const path="https://drive.google.com/uc?id=" + url
   
    return(
   
   <div className="workout-details">
    <div className= "tryout">
    <h4> {workout.title}</h4>
    <p><strong>Brand: </strong>{workout.brand}</p>
    <p> <strong> Price:$</strong> {workout.price}</p>
    <p>{workout.createdAt}</p>
    </div>
    <div className="work1">
    <img src={path} alt= "no pic"/>
    </div>
    <button onClick={handleClick}>delete</button>
   </div>
    )
}

export default WorkoutDetails